<sirius-card-catalog
    [title]="robot().name"
    [teaserHtml]="robot().teaserHtml ?? ''"
    [image]="cardImage()"
    [imageData]="imageData()"
    [attributes]="cardAttributes()"
    [properties]="robot().properties"
    [link]="productLink()"
    container="grid"
/>
